const initialState = null;

const similarAds = (state = initialState, action) => {
	switch (action.type) {
		case 'GET_SIMILAR_ADS_SUCCESS':
			return Object.assign({},state,{ ...action.payload });
		case 'GET_SIMILAR_ADS_FAILURE':
			return Object.assign({},state, {});
		default:
			return state;
	}
};

export default similarAds;



// WEBPACK FOOTER //
// ../q-cars/src/redux/reducers/similarAds.js